import { render } from "./App.vue?vue&type=template&id=2fc8f918&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2fc8f918&lang=scss"

import exportComponent from "D:\\Ait\\NHRC\\src\\NHRC_Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__